import { jsx as e } from "react/jsx-runtime";
import { c as l } from "../../index-BkL7vJ-E.js";
import { s as t } from "../../IPCheck.module-D80DEiWS.js";
const s = ({ className: o, children: r }) => /* @__PURE__ */ e("div", { className: l(t.ipNotAllowedCover, o, "hamrah-player__check-ip__not-allowed"), children: r ?? "کاربر گرامی, برای تماشای این فیلم از اینترنت همراه اول یا ایرانسل استفاده نمایید." });
export {
  s as default
};
